import { useAuthConfig, useCurrentUser } from "../lib/auth";

import SignInPage from "./SignInPage";


export default function AuthGate({ children }: { children: React.ReactNode }) {
  const cfg = useAuthConfig();
  const me = useCurrentUser();

  if (cfg.isLoading) {
    return <Loading />;
  }
  if (cfg.data && !cfg.data.enabled) {
    return <>{children}</>;
  }

  if (me.isLoading) {
    return <Loading />;
  }
  if (me.isError || !me.data) {
    return <SignInPage />;
  }
  return <>{children}</>;
}


function Loading() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50">
      <p className="text-sm text-slate-500">Loading…</p>
    </main>
  );
}
